import { render, staticRenderFns } from "./album-details.vue?vue&type=template&id=fa57b8e0"
import script from "./album-details.vue?vue&type=script&lang=js"
export * from "./album-details.vue?vue&type=script&lang=js"
import style0 from "./album-details.vue?vue&type=style&index=0&id=fa57b8e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports